module.exports = __webpack_public_path__ + "img/nomad.3929b800.svg";